import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { CompletedCourse } from "./completedCourse";
import { CourseEnrollment } from "./courseEnrollment";
import { Timestamp } from "firebase/firestore";
import { DocumentReference } from "@angular/fire/compat/firestore";

import { Language } from "../utils/language";
import { AssignedCategory } from "./assignedCategory";
import { Category } from "./category";

export class CategoryEnrollment extends FBase {

	userId: string = null;
	name: string = null;
	description: string = null;
	completedCourses: CompletedCourse[] = [];
	totalCourses: number = null;
	completedAt: Timestamp = null;
	startDate: Timestamp = null;
	expirationDate: Timestamp = null;
	image: string = null;
	selectedLanguage: Language = null;
	languages: Language[] = [];
	translated: boolean = false;
	completedPercentage: number = 0;
	completedForm: boolean = false;
	languageCategoryReference: DocumentReference = null;
	attestationSignedAt: Timestamp = null;
	attestationSignatureUrl: string = null;
	// Per-learner override of the category's own setting, written by the auto-grant-retakes endpoint.
	// Null means this enrollment follows the category, which is the case for every enrollment that has
	// never been set through that endpoint.
	autoGrantRetakes: boolean = null;
	// Persisted on the enrollment doc as `enforce_course_order`; a per-learner
	// override of the category's own flag. Null means "follow the category".
	enforceCourseOrder: boolean = null;

	__coursesEnrollments: CourseEnrollment[] = [];
	__assignedCategory: AssignedCategory;
	// The category document this enrollment came from, loaded alongside the
	// enrollment so consumers don't need their own round trip for it.
	__category: Category = null;

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}
}

export namespace CategoryEnrollment {

	export const PATH = 'categoryEnrollments';

}
